<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex lg4 >
                <resultado-card v-if="resultado" :resultado="resultado"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import axios from 'axios'
  import ResultadoCard from '@/components/ResultadoCard'

  export default {
    name: 'resultados-paciente',
    data () {
      return {
        resultado: {}
      }
    },
    components: {
      ResultadoCard
    },
    methods: {
      atualizarLista () {
        var params = `resultado=${this.$route.params.resultado}`
        axios.get(`/resultado?${params}`)
          .then(response => {
            // JSON responses are automatically parsed.
            /* this.cabecalho = response.data.cabecalho
            this.changeThemeColor(response.data.cabecalho)
            this.$store.commit('changeCabecalho', {cabecalho: this.cabecalho}) */
            this.resultado = response.data.resultado
            this.$store.commit('changeMenu', {
              r: this.resultado.id
            })
          })
          .catch(e => {
            console.log(e.response.status)
            this.$router.push({name: 'NotFound'})
          })
      }
    },
    // Fetches medicos when the component is created.
    created () {
      this.atualizarLista()
    }
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>



// WEBPACK FOOTER //
// ResultadoPaciente.vue?28f53f24